import type { FaireProductEntity } from "../../entity_types/product";

export const p_nb2pp2ua76: FaireProductEntity = {
  token: "p_nb2pp2ua76",
  type: "product",
  name: "Assorted All-Natural Vegan Macarons",
  brandToken: "b_384hnspyq8",
  brandName: "macaron centrale",
  imageUrl:
    "https://cdn.faire.com/fastly/b815032ac9c9e005d30dd46de4024df2ca4abd37bccc77f35a52efbd2d5f58be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67e9a68b6430f3e585d2b0bec566947289834f3bfa42c0bb34a466fa1633a350.jpeg",
    "https://cdn.faire.com/fastly/77920a7c9bb3f29b5b09b67363e1303dbd7b82a41a3b8a20f0982e7c02fb58f7.jpeg",
    "https://cdn.faire.com/fastly/b1706bec99493dc6e5b1e90861a04f25be8daad1c04e66a22800db3ffa16b3d1.png",
  ],
  priceDollars: 3.46,
  description:
    "Experience the pure essence of plant-based indulgence with our All-Natural Vegan Macaron Assortment, made without artificial colors or flavors. This wholesale-ready 6-pack features six carefully crafted flavors, each made with natural ingredients for a truly authentic taste:\nThe assortment will include some or all of the following:\n\n🍓 Raspberry – A light pink macaron bursting with natural raspberry sweetness.\n🎉 Birthday – A festive macaron with colorful sprinkles, infused with warm vanilla notes.\n🍵 Earl Grey – A grey macaron speckled with Earl Grey tea leaves, offering floral and citrusy depth.\n☕ Thai Coffee – A bold brown macaron infused with rich Thai iced coffee flavors.\n🍍 Pineapple – A bright yellow macaron with white nonpareils, delivering a tropical and creamy finish.\n🍋 Lemon Açaí – A refreshing blend of tangy lemon and antioxidant-rich açaí, for a vibrant fruity twist.\n🫐 Blueberry -A bright blend of pure blueberry and natural sweetness, offering a clean, fruity burst in every bite.\n🍊Orange Cream - A refreshing burst of orange wrapped in a soft, creamy sweetness for the perfect citrus treat.\n\nEach pack includes one of each flavor, totaling 6 macarons per box, making it an ideal offering for cafés, bakeries, and retailers catering to clean, plant-based d",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:58.454Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
